// axios
import axios from "axios";
// @ts-ignore
import Cookies from "js-cookie";

export const SendTicketMessage = async (data: any) => {
    let token = Cookies.get('agent_token');
    let id = data.id;
    delete data.id
    let ClientOption: any = {
        headers: {
            'APIKEY': process.env.REACT_APP_API_CLIENT_KEY,
            Authorization: `Bearer ${token}`,
        }
    };
    const { data: response } = await axios.post(`${process.env.REACT_APP_API_URL}user/tickets/${id}/messages`, data, ClientOption);
    return response.data;
}